import { Component, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  template: `
    <div class="snackbar">
      <div class="snackbar__text">
        <h5>No network connection.</h5>
        <p>Check the connection and try again.</p>
      </div>
      <button mat-raised-button
        color="accent"
        (click)="snackBarRef.dismiss()"
      >
        OK
    </button>
    </div>`,
  styleUrls: [`../snack-bar.scss`],
  encapsulation: ViewEncapsulation.None,
})
export class NetworkConnectionErrorComponent {
  constructor( public snackBarRef: MatSnackBarRef<any>){}
}
